<template>
    <div>
        <router-view @refresh="refresh()"></router-view>
        <header class="content-header">
            <div class="wrapper">

                <div>
                    <h1>Categories</h1>
                    <p>Gestion des méthodes de paiements</p>
                </div>

                <div class="actions">
                    <ul>
                        <li><button class="bt-primary" @click="saveTree()"><span>Sauvegarder</span></button></li>
                    </ul>
                </div>

            </div>
        </header>

        <filters v-model="filters" :paginator="paginator" :menus="menus" active-nav="true" active-advanced-filter="false" active-tabs="true" @refresh="refresh()" @setFilter="setFilter"></filters>

        <div class="content-body">

            <section>
                <div class="tree">
                    <sortable-tree :data="treeData" mixinParentKey="$parent" @changePosition="changePosition" :dragEnable="true" closeStateKey="$foldClose">
                        <template slot-scope="{item}">
                            <div class="custom-tree-content" :class="{'exitChild': item.children && item.children.length}">
                            <span>
                                <span v-if="item['$foldClose'] && item.children && item.children.length" @click="changeState(item)"><i class="icon icon-expand"></i></span>
                                <span v-else-if="!item['$foldClose'] && item.children && item.children.length" @click="changeState(item)"><i class="icon icon-collapse"></i></span>
                            </span>
                                <div>
                                    <span class="name">{{item.name}}</span>
                                    <span class="ident">{{item.id}}</span>
                                    <span class="ident">{{item.parent_id}}</span>
                                    <span class="actions">
                                    <ul>
                                        <li><button @click="remove(item.id)"><icon name="trash-01"/></button></li>
                                        <li><button @click="edit(item.id)"><icon name="pencil-02"/></button></li>
                                    </ul>
                                </span>
                                </div>
                            </div>
                        </template>
                    </sortable-tree>
                </div>

            </section>




        </div>
    </div>
</template>
<script>
    import CategoryService from './CategoryService.js';
    import Index from '../../../layouts/Index.vue';

    export default {
        extends: Index,
        data () {
            return {
                treeData: {
                    name: 'root',
                    children: []
                },
                menus: [
                    {
                        slug: 'category',
                        name: 'Categories'
                    },
                    {
                        slug: 'category-tree',
                        name: 'Tree'
                    }
                ]
            }
        },
        mounted: function(){
            this.refresh()
            this.getResource().tree().then((response) => {
                //console.log('tree', response);
                this.treeData.children = response.data;
            })
        },
        methods: {
            getResource: function(){
                return CategoryService;
            },
            consoleData () {
                //console.log(this.treeData)
            },
            changeState (item) {
                this.$set(item, '$foldClose', !item['$foldClose'])
            },
            changePosition (option) {
                console.log('changePosition: ', option)
            },
            recursive: function(data){
                let children = []
                for (let item of data) {
                    let child = this.recursive(item.children);
                    children.push({
                        id: item.id,
                        parent_id: item.parent_id,
                        depth: item.depth,
                        children: child
                    })
                }
                return children
            },
            saveTree(){
                let data = this.recursive(this.treeData.children);
                //console.log('tree', data)
                this.getResource().saveTree({data: data}).then((response) => {
                    //console.log('tree', response.data);
                    this.treeData.children = response.data
                })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/shop/category/Tree.vue